module.exports = __webpack_public_path__ + "static/img/delay.7cd2ebd4.svg";